import {connect} from '../../app/connect';
import IssueNewModal from './IssueNewModal';
import {actions as formActions} from 'react-redux-form';
import {changeLocationAction} from '../../app/actions';
import {
  getPendingIssueForm,
  getAppLoading,
  getFieldIssueMandatoryDataLoading,
  isTemplateCategoriesCollectionLoading
} from '../../app/selectors';
import {getIsFetchingActiveTemplates} from '../../app/templates/template-selectors';

const mapStateToProps = state => ({
  pendingIssueForm: getPendingIssueForm(state),
  loading:
    getAppLoading(state) ||
    getFieldIssueMandatoryDataLoading(state) ||
    isTemplateCategoriesCollectionLoading(state) ||
    getIsFetchingActiveTemplates(state)
});

const {reset: resetFormAction, resetValidity: resetValidityFormAction} = formActions;

export default connect(
  mapStateToProps,
  {
    changeLocationAction,
    resetFormAction,
    resetValidityFormAction
  }
)(IssueNewModal);
